import type { GroupInfo, MaterialKind } from "../../../shared/api-contract";
import type { AppliedStep, BasicEngine } from "./applyEngine";

/**
 * Make a part a stone (a clear diamond) or metal (white gold, polished) —
 * reclassified and re-dressed as ONE Undo step. Basic's "Is a part wrong?"
 * switch and the customer configurator's "Make them stones again" are this
 * same step.
 */
export function fixPartKind(engine: BasicEngine, g: GroupInfo, kind: MaterialKind): Promise<AppliedStep | null> {
  return engine.applySuggestions(
    [{ groupId: g.id, kind, changeKind: true, mark: kind === "gem" ? { presetId: "diamondClear" } : { presetId: "whiteGold", finishId: "polished" } }],
    `${g.label || "Part"} is now ${kind === "gem" ? "a stone" : "metal"}`,
  );
}
